import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./About.css";
import "../App.css";
import OurBlogs from "./OurBlogs";
import AboutUsBannerMobile from "../assets/contact_us_banner_mobile.webp";
import AboutUsBanner from "../assets/contact_us_banner.webp";
import FaQ from "./FaQ";
import { FaPhone, FaEnvelope, FaLocationDot } from "react-icons/fa6";

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  const bannerImage = isMobile ? AboutUsBannerMobile : AboutUsBanner;

  return (
    <>
      <section className="w-100 position-relative mb-5">
        <div className="container-fluid p-0">
          <div
            className="position-relative w-100 d-flex hero-banner"
            style={{
              minHeight:
                windowWidth <= 768
                  ? "520px" // Mobile
                  : windowWidth <= 1024
                  ? "400px" // Tablet
                  : windowWidth <= 1600
                  ? "650px" // Medium Desktop
                  : "750px", // Large Desktop
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundImage: `url(${bannerImage})`,
              alignItems: windowWidth <= 768 ? "flex-start" : "center",
              paddingTop: windowWidth <= 768 ? "50px" : "0",
            }}
          >
            {/* Overlay */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 1,
              }}
            ></div>

            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-1"></div>
                <div
                  className="col-10"
                  style={{
                    position: "relative",
                    zIndex: 2,
                    width:
                      windowWidth <= 768
                        ? "90%"
                        : windowWidth <= 1024
                        ? "70%"
                        : "55%",
                    textAlign: windowWidth <= 768 ? "center" : "left",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: windowWidth <= 768 ? "center" : "flex-start",
                  }}
                >
                  <div className="text-gray text-start">
                    <h1
                      className="fw-semibold mb-2"
                      style={{
                        fontSize:
                          windowWidth <= 768
                            ? "24px"
                            : windowWidth <= 1024
                            ? "30px"
                            : "35px",
                        textAlign: "left",
                        lineHeight: "1.2",
                        fontWeight: "700",
                      }}
                    >
                      Delivers Expert Financial
                      <br /> Solutions for Growth.
                    </h1>
                    <p
                      className="mb-4"
                      style={{
                        fontSize:
                          windowWidth <= 768
                            ? "14px"
                            : windowWidth <= 1024
                            ? "20px"
                            : "18px",
                        textAlign: "left",
                        maxWidth: "500px",
                      }}
                    >
                      Unlock funds in minutes with flexible repayment options,
                      minimal paperwork, and 100% secure storage
                    </p>
                  </div>
                </div>
                <div className="col-1"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container-fluid position-relative w-100">
        <div className="row justify-content-center">
          <div className="col-lg-2 d-none d-lg-block"></div>
          <div className="col-12 col-lg-8 px-3 px-md-4">
            <div className="row justify-content-center mb-5">
              <div className="col-xl-12">
                <div className="bg-light rounded-4 overflow-hidden">
                  <div className="row g-0">
                    <div className="col-lg-6">
                      <div className="p-2 p-md-5 h-100 d-flex flex-column">
                        <h4
                          className="fw-semibold"
                          style={{ fontSize: "32px" }}
                        >
                          Contact us
                        </h4>
                        <p className="text-muted mt-4">
                          We're not just about numbers—we're about people. Talk
                          to our team and find financial solutions that truly
                          fit your needs.
                        </p>

                        <div className="d-flex flex-column gap-4 mt-4 mb-3">
                          <div className="d-flex align-items-center">
                            <div
                              className="bg-primary text-white rounded-circle p-1 me-3 d-flex justify-content-center align-items-center"
                              style={{ width: "40px", height: "40px" }}
                            >
                              <FaPhone size={18} />
                            </div>
                            <p className="text-secondary mb-0">
                              +91 9958853167
                            </p>
                          </div>

                          <div className="d-flex align-items-center">
                            <div
                              className="bg-primary text-white rounded-circle p-1 me-3 d-flex justify-content-center align-items-center"
                              style={{ width: "40px", height: "40px" }}
                            >
                              <FaEnvelope size={18} />
                            </div>
                            <p className="text-secondary mb-0">
                              shubhpaisa@support.com
                            </p>
                          </div>

                          <div className="d-flex align-items-center">
                            <div
                              className="bg-primary text-white rounded-circle p-1 me-3 d-flex justify-content-center align-items-center"
                              style={{ width: "40px", height: "40px" }}
                            >
                              <FaLocationDot size={18} />
                            </div>
                            <div>
                              <p
                                className="text-secondary mb-0"
                                style={{ fontSize: "14px", lineHeight: "1.6" }}
                              >
                                Ithum, Tower-B, 218, Second Floor <br />
                                Sector 62, Noida-201309
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6 p-0">
                      <div className="h-100" style={{ minHeight: "400px" }}>
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7004.165748472375!2d77.3673534556453!3d28.627278184318282!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5f6bf0e729b%3A0x4c68e44d9e70a67f!2sI-Thum%20Tower%20-%20office%20space%20in%20IThum%20Noida%20Sector%2062!5e0!3m2!1sen!2sin!4v1751014402395!5m2!1sen!2sin"
                          width="100%"
                          className="w-100 h-100"
                          style={{ border: 0, minHeight: "400px" }}
                          allowFullScreen=""
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-2 d-none d-lg-block"></div>
        </div>
      </div>
      <FaQ />
      <OurBlogs />
    </>
  );
};

export default Contact;
